module.exports = __webpack_public_path__ + "img/Evaluation Process_02_overview.73b1e0b3.jpg";